module.exports = __webpack_public_path__ + "img/url_icon_hover.a311609c.svg";